export const searchOptions = (options, query, isSearchAtStart) => {
  return options.reduce((acc, option) => {
    if (option.isSelectable && searchOption(option.label, query, isSearchAtStart)) {
      acc.push({ ...option, label: getHighlightedText(option.label, query), display: true });
      return acc;
    }

    if (option.children) {
      const matchedChildren = searchOptions(option.children, query, isSearchAtStart);
      if (matchedChildren.length) {
        acc.push({
          ...option,
          children: matchedChildren,
          display: !matchedChildren.every((child) => child.display === false),
        });
      }

      return acc;
    }

    acc.push({ ...option, display: false });
    return acc;
  }, []);
};

const searchOption = (option, query, isSearchAtStart = false) => {
  if (isSearchAtStart) {
    return option.toLowerCase().startsWith(query.toLowerCase());
  }

  return option.toLowerCase().includes(query.toLowerCase());
};

const getHighlightedText = (text, query) => {
  const regex = new RegExp(`(${query})`, 'gi');
  return text.replace(regex, '<strong>$1</strong>');
};
